// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2dST5","title":"ClientInsurance_title__bwxF3","itemText":"ClientInsurance_itemText__13_p1"};